export default "__VITE_ASSET__205ae3cb__"